import Marquee from "react-fast-marquee";
import {
  person1,
  person2,
  person3,
  person4,
  quoteBg_Normalwhite,
  quoteBg_coldWhite,
} from "../../../../../public/assets";
import Quote from "../Quote/Quote";
import { CarouselContainer } from "./Carousel.styles";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLocale } from "../../../../locales/localeSlice";

const TestimonialCarousel = () => {
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);
  return (
    <>
      <CarouselContainer>
        <Marquee>
          <Quote
            avatar="/assets/heroAvatars/person1.png"
            quoteBg="/assets/svg/Review_background_white-removebg-preview.png"
            review={t("reviewsSection.reviewsContent", {
              lng: currentLocale,
            })}
          />
          <Quote
            avatar="/assets/heroAvatars/person2.png"
            quoteBg="/assets/svg/Review_COLDwhite-removebg_shadow-preview.png"
            review={t("reviewsSection.reviewsContent", {
              lng: currentLocale,
            })}
          />
          <Quote
            avatar="/assets/heroAvatars/person3.png"
            quoteBg="/assets/svg/Review_background_white-removebg-preview.png"
            review={t("reviewsSection.reviewsContent", {
              lng: currentLocale,
            })}
          />
          <Quote
            avatar="/assets/heroAvatars/person4.png"
            quoteBg="/assets/svg/Review_COLDwhite-removebg_shadow-preview.png"
            review={t("reviewsSection.reviewsContent", {
              lng: currentLocale,
            })}
          />
        </Marquee>
      </CarouselContainer>
    </>
  );
};

export default TestimonialCarousel;
